import React, { Component } from 'react';
import { PartenaireTemplate } from './../../Templates/index';

class Partenaire extends Component {
    constructor(props) {
        super(props);
        this.state = {};
    }

    render() {
        return <PartenaireTemplate />;
    }
}
export default Partenaire;
